import React from 'react';
import ReportPageShell from './shared/ReportPageShell';

const TaxSummaryReport: React.FC = () => (
  <ReportPageShell
    reportType="tax-summary"
    title="VAT / Tax Summary"
    subtitle="Net, tax, and gross totalled per tax rate. Persisted line values — no rate × amount recalculation."
    maxRangeDays={366}
    bullets={[
      'Tax Code',
      'Tax Group',
      'Rate',
      'Net',
      'Tax',
      'Gross',
    ]}
  />
);

export default TaxSummaryReport;
